import {
  ListItemIcon,
  ListItemText,
  ListSubheader,
  MenuItem,
} from "@mui/material";
import React, { Component } from "react";
import Theme from "../common/Theme";
import SelectedIcon from "../resources/icons-check.svg";
import DropIcon from "../resources/icons-chevron-double.svg";
import TextField from "./TextField";

export default class SelectMenu extends Component<any> {
  static defaultProps = {
    noSelectionError: false,
    groups: null,
    showSelectionIcon: true,
  };

  ref: any;

  constructor(props: any) {
    super(props);

    this.ref = React.createRef();
  }

  onChange(e: any) {
    const { onChange } = this.props;
    if (e.target.value === undefined) return;

    if (onChange) onChange(e);
  }

  renderGroup(group: any) {
    const { items } = this.props;
    return [
      <ListSubheader className="klayo-selectmenu_group">{group}</ListSubheader>,
      items
        .filter(([key, filter]: [any, any]) => filter.group === group)
        .map(([key, filter]: [any, any]) => this.renderItem(key, filter)),
    ];
  }

  renderItem(key: any, filter: any) {
    const { dense, getItemLabel, disableItem, showSelectionIcon } = this.props;

    return (
      <MenuItem
        className={
          "klayo-selectmenu_item " +
          (dense ? "klayo-selectmenu_item-dense " : "")
        }
        key={key}
        disabled={disableItem ? disableItem(filter) : false}
        value={filter}
      >
        <ListItemText>
          {getItemLabel ? getItemLabel(filter) : filter.label}
        </ListItemText>
        {showSelectionIcon && (
          <ListItemIcon>
            <SelectedIcon />
          </ListItemIcon>
        )}
      </MenuItem>
    );
  }

  render() {
    const {
      label,
      items,
      placeholder,
      disabled,
      className,
      sx,
      dense,
      onChange,
      firstValueDefault,
      getItemLabel,
      clearable,
      disableItem,
      noSelectionError,
      groups,
      autoFocus,
    } = this.props;
    let { value } = this.props;

    const defaultValue = this.props.defaultValue
      ? this.props.defaultValue
      : firstValueDefault
      ? items[0][1]
      : null;
    if (!value) value = defaultValue;

    return (
      <TextField
        className={
          "klayo-selectmenu" +
          (dense ? " klayo-selectmenu-dense" : "") +
          (className ? " " + className : "") +
          (groups ? " klayo-selectmenu-hasgroups" : "")
        }
        select
        label={label}
        dense={dense}
        value={value}
        error={noSelectionError && value === null}
        clearable={clearable}
        defaultValue={defaultValue}
        placeholder={placeholder}
        autoFocus={autoFocus}
        disabled={disabled}
        onChange={this.onChange.bind(this)}
        SelectProps={{
          MenuProps: {
            classes: {
              list:
                ".MuiMenu-list" +
                (groups ? " klayo-selectmenu_list-hasgroups" : "") +
                (dense ? " klayo-selectmenu_list-dense" : ""),
            },
          },
          IconComponent: () => (
            <DropIcon className="klayo-selectmenu_dropbutton" />
          ),
          autoWidth: false,
          displayEmpty: true,
          renderValue: (value: any) => (
            <div className="klayo-selectmenu_value">
              {value !== "" ? (
                getItemLabel ? (
                  getItemLabel(value)
                ) : (
                  value.label
                )
              ) : placeholder ? (
                <div className="klayo-selectmenu_placeholder">
                  {placeholder}
                </div>
              ) : (
                ""
              )}
            </div>
          ),
        }}
        sx={{
          ...sx,
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: Theme.getStyleVar("--neon-blue-nb-200"),
            },
            "&:hover fieldset": {
              borderColor: Theme.getStyleVar("--neon-blue-nb-300"),
            },
            "&.Mui-focused fieldset": {
              borderWidth: "2px",
              borderColor: Theme.getStyleVar("--neon-blue-nb-500"),
            },
          },
        }}
      >
        {groups && groups.map((g: any) => this.renderGroup(g))}

        {!groups &&
          items.map(([key, filter]: [string, any]) =>
            this.renderItem(key, filter)
          )}
      </TextField>
    );
  }
}
